import { render, staticRenderFns } from "./RegistroPreventa.vue?vue&type=template&id=7b68e971"
import script from "./RegistroPreventa.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistroPreventa.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports